<template>
    <section id="faq-section" class="custom-container bg-tertiary faq-section" :class="{ 'huipix-faq': isHuipix }">
        <h2 class="text-center font-lg font-bold my-1">{{ title }}</h2>
        <p>{{description}}</p>
        <div class="display-flex flex-direction-column my-1 question-item">
            <div class="w-100" v-for="(question, index) in questions" :key="index">
                <div class="row justify-content-between align-items-center" :class="{ 'open-question': question.visible }" @click="changeVisibleByIndex(index)" style="cursor: pointer;">
                    <span class="question col pr-1-span">{{question.ask}}</span>
                    <button class="show-question">
                        <i class=" " :class="['fa-solid', { 'fa-caret-up': question.visible, 'fa-caret-down': !question.visible }]"></i>
                    </button>
                </div>

                <div v-if="question.visible" class="mt-1">
                    <span  style="white-space: pre-line;">{{ capitalize(question.answer) }}</span>
                </div>
                <hr>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'frequently-asked-questions',
    props: {
        faq_data: String,
        isHuipix: Boolean
    },
    data () {
        return {
            title: '',
            description: '',
            questions: []
        }
    },
    methods: {
        changeVisibleByIndex(index) {
            const wasVisible = this.questions[index].visible
            this.questions.forEach((question, i) => {
                question.visible = i === index ? !wasVisible : false
            })
        },
        capitalize(text) {
            return text
                .split('\n')
                .map(line => line.charAt(0).toUpperCase() + line.slice(1).toLowerCase())
                .join('\n');
        }
    },
    mounted () {
        const webData = JSON.parse(this.faq_data)
        this.title = webData.title
        this.description = webData.description
        this.questions = webData.questions.map(({ask, answer}) => ({ask, answer, visible: false}))
    }
}

</script>

<style>
.pr-1-span {
    padding-right: 5px;
}
</style>